import {
  useLazyQuery,
  useMutation,
  useQuery,
  useSubscription,
} from "@apollo/client";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  MUTATE_SET_ACTIVE_IMPORT_IDS,
  QUERY_FULL_IMPORT_FOR_PREVIEW,
  QUERY_IMPORT_SUMMARIES,
  QUERY_IMPORTS,
  SUBSCRIBE_IMPORTS_UPDATE,
} from "../queries/importsQueries";
import {
  setImportPreview,
  setImports,
  setImportSummaries,
} from "../../../state/importsReducer";

export function QueryImports() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_IMPORTS);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setImports(data.getImports));
    }
  }, [dispatch, data, loading, error]);
}

export function QueryImportSummaries() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_IMPORT_SUMMARIES);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setImportSummaries(data.getImportSummaries));
    }
  }, [dispatch, data, loading, error]);
}

export function QueryFullImportForPreview() {
  const dispatch = useDispatch();
  const [queryFullImportForPreview, { data, loading, error }] = useLazyQuery(
    QUERY_FULL_IMPORT_FOR_PREVIEW,
  );

  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setImportPreview(data.getImportForPreview));
    }
  }, [dispatch, data, loading, error]);
  return (id: string, type: string) => {
    queryFullImportForPreview({ variables: { id, type } });
  };
}

export function MutateSetActiveImportIDs() {
  const [setActiveImportIDs] = useMutation(MUTATE_SET_ACTIVE_IMPORT_IDS);
  return setActiveImportIDs;
}

export function SubscribeImportsUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_IMPORTS_UPDATE, {
    onData: (x) => {
      const newImports = x.data.data.newImportsUpdate;
      dispatch(setImports(newImports));
    },
  });
  if (error) {
    console.log(error);
  }
}
